module.exports = __webpack_public_path__ + "img/lwht.e2e75322.png";